import { SiteDueDiligenceFacilityType } from '@consigli/types';
// import { useState, useCallback } from 'react';
// import { HiOutlineXMark, HiOutlinePlus } from 'react-icons/hi2';

import { Fieldset, Field, Select, TextInput } from '@/components';
import { FileUpload } from '@/components/file-upload';

export type TemplateMode = 'default' | 'custom';

const facilityTypeOptions: { label: string; value: SiteDueDiligenceFacilityType }[] = [
  { label: 'Data Center', value: SiteDueDiligenceFacilityType.DATA_CENTER },
  { label: 'Waste Water', value: SiteDueDiligenceFacilityType.WASTE_WATER },
  { label: 'Logistic', value: SiteDueDiligenceFacilityType.LOGISTIC },
  { label: 'Bridge', value: SiteDueDiligenceFacilityType.BRIDGE },
];

// const templateModeOptions: { label: string; value: TemplateMode }[] = [
//   { label: 'Default Template', value: 'default' },
//   { label: 'Custom Template', value: 'custom' },
// ];

// const customerOptions: { label: string; value: string }[] = [
//   { label: 'Customer A', value: 'customer-a' },
//   { label: 'Customer B', value: 'customer-b' },
//   { label: 'Customer C', value: 'customer-c' },
// ];

interface SiteDueDiligenceFieldsProps {
  facilityType: SiteDueDiligenceFacilityType | null;
  // templateMode: TemplateMode;
  // customTemplateFile: File | null;
  // selectedCustomer: string | null;
  locationLat: string;
  locationLon: string;
  documentFiles: File[];
  // gisFiles: File[];
  // urls: string[];
  // allowLLMForDocuments: boolean;
  errors?: Record<string, string>;
  onFacilityTypeChange: (value: SiteDueDiligenceFacilityType) => void;
  // onTemplateModeChange: (value: TemplateMode) => void;
  // onCustomTemplateFileChange: (file: File | null) => void;
  // onSelectedCustomerChange: (value: string | null) => void;
  onLocationLatChange: (value: string) => void;
  onLocationLonChange: (value: string) => void;
  onDocumentFilesChange: (files: File[]) => void;
  // onGisFilesChange: (files: File[]) => void;
  // onUrlsChange: (urls: string[]) => void;
  // onAllowLLMForDocumentsChange: (value: boolean) => void;
}

/**
 * Site Due Diligence specific fields for the document package form.
 * These fields are shown when SITE_DUE_DILIGENCE is selected as the package type.
 */
export const SiteDueDiligenceFields = ({
  facilityType,
  // templateMode,
  // customTemplateFile,
  // selectedCustomer,
  locationLat,
  locationLon,
  documentFiles,
  // gisFiles,
  // urls,
  // allowLLMForDocuments,
  errors = {},
  onFacilityTypeChange,
  // onTemplateModeChange,
  // onCustomTemplateFileChange,
  // onSelectedCustomerChange,
  onLocationLatChange,
  onLocationLonChange,
  onDocumentFilesChange,
  // onGisFilesChange,
  // onUrlsChange,
  // onAllowLLMForDocumentsChange,
}: SiteDueDiligenceFieldsProps) => {
  // const [urlInput, setUrlInput] = useState('');

  // const handleAddUrl = useCallback(() => {
  //   const trimmedUrl = urlInput.trim();
  //   if (trimmedUrl && !urls.includes(trimmedUrl)) {
  //     onUrlsChange([...urls, trimmedUrl]);
  //     setUrlInput('');
  //   }
  // }, [urlInput, urls, onUrlsChange]);

  // const handleRemoveUrl = useCallback(
  //   (urlToRemove: string) => {
  //     onUrlsChange(urls.filter((url) => url !== urlToRemove));
  //   },
  //   [urls, onUrlsChange],
  // );

  // const handleKeyDown = useCallback(
  //   (e: React.KeyboardEvent) => {
  //     if (e.key === 'Enter') {
  //       e.preventDefault();
  //       handleAddUrl();
  //     }
  //   },
  //   [handleAddUrl],
  // );

  // const handleCustomTemplateFiles = useCallback(
  //   (files: File[]) => {
  //     onCustomTemplateFileChange(files.length > 0 ? files[0] : null);
  //   },
  //   [onCustomTemplateFileChange],
  // );

  return (
    <Fieldset legend="Site Due Diligence Details">
      <p className="text-sm text-gray-500 mb-4">
        Configure the site due diligence analysis settings
      </p>

      {/* Facility Type */}
      <Field
        label="Facility Type"
        htmlFor="facility-type-select"
        required
        error={errors.facilityType}
      >
        <Select
          options={facilityTypeOptions}
          placeholder="Select Facility Type"
          value={facilityTypeOptions.find((opt) => opt.value === facilityType)}
          onValueChange={(option) => onFacilityTypeChange(option.value)}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value ?? ''}
          className="w-full"
        />
      </Field>

      {/* Template Mode */}
      {/* <Field label="Template" htmlFor="template-mode-select" error={errors.templateMode}>
        <Select
          options={templateModeOptions}
          placeholder="Select Template Mode"
          value={templateModeOptions.find((opt) => opt.value === templateMode)}
          onValueChange={(option) => onTemplateModeChange(option.value)}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          className="w-full"
        />
      </Field> */}

      {/* Custom Template File Upload */}
      {/* {templateMode === 'custom' && (
        <Field label="Custom Template File" htmlFor="custom-template-file">
          <FileUpload
            setFiles={handleCustomTemplateFiles}
            placeholder="Upload custom template (.xlsx, .xls, .doc, .docx, .pdf)"
            files={customTemplateFile ? [customTemplateFile] : []}
          />
        </Field>
      )} */}

      {/* Customer (only for data-center) */}
      {/* {facilityType === SiteDueDiligenceFacilityType.DATA_CENTER && (
        <Field label="Customer" htmlFor="customer-select" error={errors.selectedCustomer}>
          <Select
            options={customerOptions}
            placeholder="Select Customer"
            value={customerOptions.find((opt) => opt.value === selectedCustomer) ?? undefined}
            onValueChange={(option) => onSelectedCustomerChange(option.value)}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            className="w-full"
          />
        </Field>
      )} */}

      {/* Location */}
      <div className="grid grid-cols-2 gap-4">
        <Field label="Latitude" htmlFor="location-lat-input" error={errors.locationLat}>
          <TextInput
            placeholder="e.g., 59.9139"
            value={locationLat}
            onChange={(e) => onLocationLatChange(e.target.value)}
            className="w-full"
          />
        </Field>
        <Field label="Longitude" htmlFor="location-lon-input" error={errors.locationLon}>
          <TextInput
            placeholder="e.g., 10.7522"
            value={locationLon}
            onChange={(e) => onLocationLonChange(e.target.value)}
            className="w-full"
          />
        </Field>
      </div>

      {/* Document Files */}
      <Field label="Data Room Documents" htmlFor="document-files-input">
        <p className="text-xs text-gray-500 mb-2">
          Upload documents for analysis (PDF, Word, Excel, etc.)
        </p>
        <FileUpload
          setFiles={onDocumentFilesChange}
          placeholder="Upload data room documents"
          files={documentFiles}
        />
      </Field>

      {/* GIS Files */}
      {/* <Field label="GIS Files" htmlFor="gis-files-input">
        <p className="text-xs text-gray-500 mb-2">
          Upload GIS/geospatial data files (Shapefile, GeoJSON, KML, etc.)
        </p>
        <FileUpload setFiles={onGisFilesChange} placeholder="Upload GIS files" files={gisFiles} />
      </Field> */}

      {/* LLM Consent */}
      {/* {documentFiles.length > 0 && (
        <Field label="" htmlFor="llm-consent">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={allowLLMForDocuments}
              onChange={(e) => onAllowLLMForDocumentsChange(e.target.checked)}
              className="w-4 h-4"
            />
            <span className="text-sm text-gray-700">
              Allow AI/LLM processing of uploaded documents
            </span>
          </label>
        </Field>
      )} */}

      {/* URLs */}
      {/* <Field label="URLs" htmlFor="urls-input">
        <p className="text-xs text-gray-500 mb-2">
          Add relevant URLs for the site due diligence analysis
        </p>
        <div className="flex gap-2">
          <TextInput
            placeholder="Enter URL and press Enter or click Add"
            value={urlInput}
            onChange={(e) => setUrlInput(e.target.value)}
            onKeyDown={handleKeyDown}
            className="flex-1"
          />
          <button
            type="button"
            onClick={handleAddUrl}
            disabled={!urlInput.trim()}
            className="px-3 py-2 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded border border-gray-300 flex items-center gap-1"
          >
            <HiOutlinePlus className="w-4 h-4" />
            Add
          </button>
        </div>
        {urls.length > 0 && (
          <ul className="mt-2 space-y-1">
            {urls.map((url) => (
              <li
                key={url}
                className="flex items-center justify-between p-2 bg-gray-50 rounded border"
              >
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 hover:underline truncate flex-1 mr-2"
                >
                  {url}
                </a>
                <button
                  type="button"
                  onClick={() => handleRemoveUrl(url)}
                  className="p-1 hover:bg-gray-200 rounded"
                >
                  <HiOutlineXMark className="w-4 h-4" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </Field> */}
    </Fieldset>
  );
};
